import angular from 'angular';
import moment from 'angular-moment';

import routing from './compare-graph-show.routes';
import SaConfigService from '../../../components/api/sa_config/sa_config.service';
import CompareBookmarkService from '../../../components/api/compare_bookmark/compare_bookmark.service';

import './compare-graph-show.css';

export class CompareGraphController {
  /*@ngInject*/
  constructor($stateParams, $state, $scope, $location, $interval, $mdDialog, moment, SaConfigService, CompareBookmarkService) {
    this.$state = $state;
    this.$location = $location;
    this.$mdDialog = $mdDialog;
    this.moment = moment;

    this.SaConfigService = SaConfigService;
    this.CompareBookmarkService = CompareBookmarkService;

    const idList = $stateParams.ids.split(',');
    this.configIds = [];
    if (idList[0] !== '') {
      this.configIds = idList.map(e => parseInt(e));
    }

    this.type = $stateParams.type;
    this.term = $stateParams.term;
    this.graphType = $stateParams.graphType;
    this.registered = false;
    this.query = `${$stateParams.ids}?type=${$stateParams.type}&term=${$stateParams.term}&graphType=${$stateParams.graphType}`;
    this.targetDate = $stateParams.date ? new Date(parseInt($stateParams.date)) : moment().startOf('day').toDate();
    this.weekTargetDate = $stateParams.wdate ? new Date(parseInt($stateParams.wdate)) : moment().startOf('week').toDate();
    this.monthTargetDate = $stateParams.mdate ? new Date(parseInt($stateParams.mdate)) : new Date();

    this.saConfigs = [];
    this.selectedConfigs = [];
  }

  $onInit() {
    this.CompareBookmarkService.show({id: this.query}, res => {
      this.registered = true;
      this.bookmarkName = res.name;
    });

    this.SaConfigService.api.index(res => {
      this.saConfigs = res;
      const selectedConfigs = [];
      for (let config of this.saConfigs) {
        if (this.configIds.indexOf(config.id) !== -1) {
          selectedConfigs.push(config);
          config.checked = true;
        }
      }
      this.selectedConfigs = selectedConfigs;
    });
  }

  changeType(type) {
    this.type = type;
    this.updateParam();
  }

  changeTerm(term) {
    this.term = term;
    this.updateParam(true);
  }

  changeGraphType(graphType) {
    this.graphType = graphType;
    this.updateParam();
  }

  updateParam(resetDate) {
    this.$state.go('main.compare_graph_show', {
      ids: this.configIds,
      type: this.type,
      term: this.term,
      graphType: this.graphType,
      date: resetDate ? this.moment().startOf('day').valueOf() : this.targetDate.valueOf(),
      mdate: resetDate ? this.moment().valueOf() : this.monthTargetDate.valueOf(),
      wdate: resetDate ? this.moment().startOf('week').valueOf() : this.weekTargetDate.valueOf()
    });
  }

  addList(name) {
    this.CompareBookmarkService.create({
      name: name,
      query: this.query
    }, res => {
      this.registered = true;
      this.bookmarkName = res.name;
    });
  }

  changeTargetDate(date) {
    this.targetDate = date;
  }

  changeWeekTargetDate(date) {
    this.weekTargetDate = date;
  }

  changeMonthTargetDate(date) {
    this.monthTargetDate = date;
  }

  toggleBookmark($event) {
    if (this.registered) {
      this.CompareBookmarkService.destroy({id: this.query}, () => {
        this.registered = false;
      });
      return;
    }

    const parent = angular.element(document.body);
    this.$mdDialog.show({
      parent: parent,
      targetEvent: $event,
      template: require('./compare-graph-show-dialog.html'),
      /*@ngInject*/
      controller: ($scope, $mdDialog, $filter) => {
        $scope.bookmarkName = '';
        $scope.defaultName = `比較グラフ（${$filter('date')(new Date(), 'yyyy-MM-dd')}）`;

        $scope.closeDialog = () =>  {
          $mdDialog.cancel();
        };

        $scope.enterInput = ($event) =>  {
          if ($event.which === 13) {
            $scope.submit();
          }
        };

        $scope.submit = () =>  {
          let name = $scope.bookmarkName;
          if (name === '') {
            name = $scope.defaultName;
          }
          $mdDialog.hide(name);
        };
      }
    }).then(name => {
      this.addList(name);
    });
  }
}

export default angular.module('leptonApp.compareGraph', [moment, SaConfigService, CompareBookmarkService])
  .config(routing)
  .component('compareGraph', {
    template: require('./compare-graph-show.html'),
    controller: CompareGraphController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/compare-graph/show/compare-graph-show.component.js